export default __webpack_public_path__ + "static/media/blackClock.13cb5875.svg";